var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("timeline-item-card", {
    scopedSlots: _vm._u([
      {
        key: "body",
        fn: function () {
          return [
            _c(
              "b-row",
              { staticClass: "align-items-center mt-2" },
              _vm._l(_vm.options, function (option, key) {
                return _c("b-col", { key: key, attrs: { cols: "12" } }, [
                  _c(
                    "p",
                    [
                      _c("span", { staticClass: "text-primary" }, [
                        _vm._v(
                          " " + _vm._s(_vm._f("camelToSentence")(key)) + ": "
                        ),
                      ]),
                      _vm._v(" "),
                      _c("client-profile-name-label", {
                        attrs: {
                          "client-profile": _vm.parseMergeOption(option),
                        },
                      }),
                    ],
                    1
                  ),
                ])
              }),
              1
            ),
          ]
        },
        proxy: true,
      },
      {
        key: "footer",
        fn: function () {
          return [
            _c(
              "b-row",
              {
                staticClass: "align-items-center justify-content-between",
                attrs: { "no-gutters": "" },
              },
              [
                _c("i18n", {
                  staticClass: "mb-0",
                  attrs: { path: "client-profile.changelog.merge", tag: "p" },
                  scopedSlots: _vm._u([
                    {
                      key: "name",
                      fn: function () {
                        return [
                          _c("span", [
                            _vm._v(
                              "\n            " +
                                _vm._s(_vm.getChangelogName(_vm.userDetails)) +
                                "\n          "
                            ),
                          ]),
                        ]
                      },
                      proxy: true,
                    },
                    {
                      key: "mergedClientProfile",
                      fn: function () {
                        return [
                          _c("client-profile-name-label", {
                            attrs: { "client-profile": _vm.value.to },
                          }),
                        ]
                      },
                      proxy: true,
                    },
                  ]),
                }),
                _vm._v(" "),
                _c("p", { staticClass: "tiny-f mb-0" }, [
                  _vm._v(
                    "\n        " +
                      _vm._s(_vm._f("formatDateHour")(_vm.insertionTimestamp)) +
                      "\n      "
                  ),
                ]),
              ],
              1
            ),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }